import { create } from "zustand";

// Globalny modal potwierdzający przeniesienie elementu (plik z Dysku / przesyłka)
// do kosza. Otwierany centralnie z hooków usuwających (useDeleteDossier /
// useDeleteList). Użytkownik może zaznaczyć „Nie pokazuj ponownie" — wybór
// trwale zapisujemy w localStorage pod tym kluczem.
export const TRASH_CONFIRM_HIDE_KEY = "trashMovedHideModal";

interface TrashConfirmModalState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export const useTrashConfirmModalStore = create<TrashConfirmModalState>(
  (set) => ({
    isOpen: false,
    // Nie otwieraj, jeśli użytkownik wcześniej wybrał „Nie pokazuj ponownie".
    open: () => {
      if (localStorage.getItem(TRASH_CONFIRM_HIDE_KEY) === "true") {
        return;
      }
      set({ isOpen: true });
    },
    close: () => set({ isOpen: false }),
  }),
);
